module.exports = __webpack_public_path__ + "img/www.bookatable.co.uk.4d2a4389.png";